/** @format */

import { Component, EventEmitter, Input, Output } from "@angular/core";
import {
	AbstractControl,
	FormBuilder,
	FormGroup,
	ValidatorFn,
	Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { ApiServiceService } from "../../../../../Services/api-service.service";
import alertify from "alertifyjs";
import { FormService } from "../form.service";
import { DatePipe } from "@angular/common";

@Component({
	selector: "app-corporate-data",
	templateUrl: "./corporate-data.component.html",
	styleUrls: ["./corporate-data.component.css"],
	providers: [DatePipe],
})
export class CorporateDataComponent {
	firstForm: FormGroup;
	PassErrorMsg: string = "";
	errorMSG: string;
	isValidating: boolean = false;

	constructor(
		private apiServer: ApiServiceService,
		private datePipe: DatePipe,
		private formService: FormService,
	) {}

	screenHeight = window.screen.height - 271; // 1058
	minHeight = "min-height: " + this.screenHeight + "px !important";

	screenHeight2 = window.screen.height - 630; // 428
	minHeight2 = "min-height: " + this.screenHeight2 + "px !important";

	eyeOpen: boolean = false;
	eyeOpenConfirm: boolean = false;

	ngOnInit() {
		this.firstForm = this.formService.getForm();
	}
	toggleEye() {
		this.eyeOpen = !this.eyeOpen;
	}
	toggleEyeConfirm() {
		this.eyeOpenConfirm = !this.eyeOpenConfirm;
	}
	onSubmit() {
		if (this.formService.businessDetailsGroup.invalid) {
			return;
		}
		if (
			this.formService.businessDetailsGroup.get("password").value !==
			this.formService.businessDetailsGroup.get("confirm_password").value
		) {
			this.PassErrorMsg = "Password Mis-matched!";
			setTimeout(() => {
				this.PassErrorMsg = "";
			}, 10000);
			return;
		}
		this.nextStep();
	}

	checkPassword() {
		if (
			this.formService.businessDetailsGroup.get("password").value !==
			this.formService.businessDetailsGroup.get("confirm_password").value
		) {
			this.errorMSG = "Password Mis-matched!";
			setTimeout(() => {
				this.errorMSG = "";
			}, 10000);
			return;
		}
	}

	valid: boolean = false;
	validateRcNumber() {
		const rcNumber =
			this.formService.businessDetailsGroup.get("rcNumber").value;
		if (rcNumber == "") {
			alertify.error("Enter a valid CAC RC Number (RC/IT/LP/LLP)");
			return;
		}

		const companyName = this.formService.businessDetailsGroup.get("companyName").value;
		if (companyName == "") {
			alertify.error("Enter a valid Company Name");
			return;
		}

		const payload: any = {
			rcNumber: rcNumber,
			entityName: companyName
		};

		this.isValidating = true;
		this.apiServer
			.postUser("/assessments/vas-company-validation-rc", payload)
			.subscribe({
				next: (res) => {
					this.isValidating = false;
					const data = res?.data;
					if (!data) {
						this.valid = false;
						alertify.error("Invalid CAC RC Number (RC/IT/LP/LLP)");
						return;
					}
					this.valid = true;
					const regDate = this.datePipe.transform(
						new Date(data.registrationDate),
						"yyyy-MM-dd",
					);
					this.formService.businessDetailsGroup.patchValue({
						business_name: data.entityName,
						rcNumber: data.rcNumber,
						regDate: regDate,
						tin:data.tin,
						entityType:data.entityType,
					});

					this.formService.businessInformationGroup.patchValue({
						businessAddress: data.address,
						dateOfIncorporation: regDate,
						rcNumber: data.rcNumber,
						jtbTin:data.tin
					});
				},
				error: (error) => {
					this.isValidating = false;
					this.valid = false;
					alertify.error(
						"Verification failed, Please try again later",
					);
				},
			});
	}
	phoneExist: boolean = false;
	emailExist: boolean = false;

	phoneExists() {
		this.apiServer
			.LoginGet(
				"/auth/utility/user/exist/phone?phone=" +
					this.formService.businessDetailsGroup.get("phone").value,
				{},
			)
			.subscribe((res) => {
				this.phoneExist = res;
			});
	}
	emailExists() {
		this.apiServer
			.LoginGet(
				"/auth/utility/user/exist/email?email=" +
					this.formService.businessDetailsGroup.get("email").value,
				{},
			)
			.subscribe((res) => {
				this.emailExist = res;
			});
	}

	nextStep() {
		this.formService.sendMessage(1);
	}

	cancel() {
		this.valid = !this.valid;
	}
}
